import React, { FC } from 'react'

import {
    Typography,
    Link,
    Button,
    styled,
} from '@material-ui/core'

import { buildReceptionLink } from '@/services/utils/links'
import { useClipboard } from '@/hooks/use-clipboard'
import { formatDate } from '@/services/utils/date-time'
import { ReservationDetails } from '@/types/reservation'

const StyledContainer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
})

const StyledMewsLink = styled('a')({
    backgroundColor: '#16191D',
    height: '52px',
    padding: '0 32px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px',
    borderRadius: '16px',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    transition: 'background-color 0.15s ease-out',

    '&:hover': {
        backgroundColor: '#596673',
    },
})


interface Props {
    readonly reservation: ReservationDetails;
}

const ReservationInfo: FC<Props> = ({ reservation } ) => {
    const [isCopied, copy] = useClipboard()

    const {
        confirmationNumber,
        status,
        property,
        startDate,
        endDate,
        origin,
        createdAt,
        slug,
        mewsUrl,
    } = reservation

    const receptionLink = buildReceptionLink(slug, property?.isWhiteLabel)
    const copyButtonText = isCopied ? 'Copied!' : 'Copy'

    return (
        <StyledContainer>
            <div>
                <h2>
                    {`Reservation ${confirmationNumber}`}
                </h2>
                <Typography>
                    {`Origin ${origin}`}
                </Typography>

                <Typography>
                    {`Status: ${status}`}
                </Typography>

                { startDate && endDate && (
                    <Typography>
                        { `From: ${ formatDate(startDate, 'yyyy/MM/dd') } to: ${ formatDate(endDate, 'yyyy/MM/dd') }` }
                    </Typography>
                ) }

                <Typography>
                    {`Created on: ${createdAt}`}
                </Typography>

                <Typography>
                    { 'Guest area link: ' }

                    <Link href={ receptionLink }>
                        { slug }
                    </Link>

                    { ' ' }

                    <Button
                        variant="outlined"
                        size="small"
                        data-id="guestAreaCopyButton"
                        onClick={ () => copy(receptionLink) }
                    >
                        { copyButtonText }
                    </Button>
                </Typography>
            </div>

            { mewsUrl && (
                <StyledMewsLink href={ mewsUrl } target="_blank" rel="noreferrer noopener">
                    Open in Mews

                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
                        <path
                            fill="#fff"
                            fillRule="evenodd"
                            d="M5 2a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V8a1 1 0 1 1 2 0v3a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h3a1 1 0 0 1 0 2H5Zm8.536 1.828V5a1 1 0 1 0 2 0V.414H11a1 1 0 1 0 0 2h1.121l-1.828 1.829a1 1 0 1 0 1.414 1.414l1.829-1.829Z"
                            clipRule="evenodd"
                        />
                    </svg>
                </StyledMewsLink>
            )}
        </StyledContainer>
    )
}

export default ReservationInfo
